function getSwiperOptions(effect) {
  let options = {
    slidesPerView: effect === "cards" ? 1 : 3.1, // change slidesPerView based on effect
    spaceBetween: 48,
    effect: effect,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
  };

  if (effect === "cards") {
    options.cardsEffect = {
      perSlideOffset: 1,
      perSlideRotate: 1,
      slideShadows: false,
    };
  }

  return options;
}

let swiperEffect = window.innerWidth > 991 ? "slide" : "cards";

var swiper = new Swiper(".clCardSliderSwiper", getSwiperOptions(swiperEffect));

// Optional: Update effect on window resize
window.addEventListener("resize", function () {
  let newEffect = window.innerWidth > 991 ? "slide" : "cards";

  if (swiper.params.effect !== newEffect) {
    swiper.destroy(true, true); // destroy current instance
    swiper = new Swiper(".clCardSliderSwiper", getSwiperOptions(newEffect));
  }
});